import type {
  CreateInvitation,
  Invitation,
  InvitationMailFields,
  InvitationRoleAvailability,
  InvitationSent,
  MailTemplate,
} from '@/types/invitation.types'
import { CLEVERLINK_API_BASE_URL, RESOURCES } from '@/constants/apiConstants'
import { resourceMutationWithBody, simpleResource } from '@/utils/apiUtils'

export const invitationsRoutes = {
  root: `${CLEVERLINK_API_BASE_URL}/${RESOURCES.INVITATIONS}`,
  list: () => invitationsRoutes.root,
  mailTemplate: () => `${invitationsRoutes.root}/mail-template`,
  mailTemplateCandidate: () =>
    `${invitationsRoutes.root}/mail-template?audience=candidat`,
  roles: () => `${invitationsRoutes.root}/roles`,
  resend: (userId: number) => `${invitationsRoutes.root}/${userId}/resend`,
}

export const fetchMailTemplate = simpleResource<MailTemplate>(
  invitationsRoutes.mailTemplate,
  'mail-template',
)

export const fetchCandidateMailTemplate = simpleResource<MailTemplate>(
  invitationsRoutes.mailTemplateCandidate,
  'mail-template-candidate',
)

export const fetchInvitationRoles = simpleResource<
  Array<InvitationRoleAvailability>
>(invitationsRoutes.roles, 'invitation-roles')

export const fetchInvitations = simpleResource<Array<Invitation>>(
  invitationsRoutes.list,
  'invitations',
)

const createInvitationRequest = resourceMutationWithBody<
  InvitationSent,
  CreateInvitation
>(invitationsRoutes.list, 'invitations', 'POST')

export const createInvitation = async (
  data: CreateInvitation,
): Promise<InvitationSent> => {
  return createInvitationRequest(data)
}

export const resendInvitation = async (
  userId: number,
  data?: InvitationMailFields,
): Promise<InvitationSent> => {
  const resendRequest = resourceMutationWithBody<
    InvitationSent,
    InvitationMailFields
  >(() => invitationsRoutes.resend(userId), 'invitations', 'POST')

  return resendRequest(data)
}
